import e from"./isObject.esm.js";function r(r){return Array.isArray(r.items)&&r.items.length>0&&r.items.every((function(r){return e(r)}))}export{r as default};
